import React, { useEffect, useState } from "react";
import {
  getBoxTypeDocuments,
  updatePlayerAttribute,
} from "../firebase/fireFuncs";
import useSizePercentage from "../hooks/useSizePercentage";
import { addPropertyToGeneralObject, objectToArray } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import BoxesOptionsBar from "./BoxesOptionsBar";
import GlobalBoxTypesList from "./GlobalBoxTypesList";
import CreateNewBoxType from "./CreateNewBoxType";
import LocalBoxTypesList from "./LocalBoxTypesList";
import { makeBoxType } from "../create/newObjects";
import { incrementBoxTypeUsed } from "../firebase/fireFuncs";
import { updateBoxTypesInStorage } from "../firebase/playerFuncs";
import boxStore from "../stores/boxStore";
import collectionStore from "../stores/collectionStore";

const useHandleBoxes = () => {
  const { player } = MainStore();
  const [areaOpen, setAreaOpen] = useState(false);
  const [selectedField, setSelectedField] = useState("browse");
  const sizePercentage = useSizePercentage();
  const { resetBoxTypeOverview } = boxStore();
  const { setGeneralObjects } = collectionStore();

  const [localTypes, setLocalTypes] = useState([]);
  const [areas, setAreas] = useState([]);

  const divs = (
    <div
      className="divColumn"
      style={{
        width: `${(1700 / 100) * sizePercentage.width}px`,
        height: "100%",
        marginTop: "15%",
        justifyContent: "start",
        zIndex: 2,
      }}
    >
      <BoxesOptionsBar
        selectedField={selectedField}
        setSelectedField={setSelectedField}
      />
      {[...areas]}
    </div>
  );

  function onDelete(boxType) {
    addPropertyToGeneralObject(boxType.names.plural, setGeneralObjects);
    const newBoxTypes = { ...player.boxTypes };
    delete newBoxTypes[boxType.names.plural];
    updateBoxTypesInStorage(newBoxTypes);
    incrementBoxTypeUsed(boxType.names.plural, -1);
    updatePlayerAttribute(player.uid, "boxTypes", newBoxTypes);
  }

  useEffect(() => {
    if (selectedField == "create")
      setAreas([
        <CreateNewBoxType
          width={"100%"}
          firstTime={true}
          onSaved={() => {
            setSelectedField("check");
          }}
        />,
      ]);
    if (selectedField == "browse")
      setAreas([<GlobalBoxTypesList onDelete={onDelete} />]);
    if (selectedField == "check")
      setAreas([<LocalBoxTypesList onDelete={onDelete} />]);
  }, [selectedField, player]);

  function openArea() {
    resetBoxTypeOverview();
    setAreaOpen(!areaOpen);
  }

  function closeArea() {
    setAreaOpen(false);
  }
  return { areaOpen, openArea, divs, closeArea };
};

export default useHandleBoxes;
